
import { Component, Prop, Vue } from 'bits/vue'

export enum OzDividerColorScheme {
  Solid = 'Solid',
  Translucent = 'Translucent',
  Popover = 'Popover',
}

export enum OzDividerOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

@Component({})
export default class OzDivider extends Vue {
  OzDividerColorScheme = OzDividerColorScheme
  OzDividerOrientation = OzDividerOrientation

  /**
   * Dark mode
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  @Prop({ required: true }) colorScheme!: OzDividerColorScheme

  /**
   * Orientation
   *
   * By default the divider is a horizontal line.
   */
  @Prop({ default: OzDividerOrientation.Horizontal }) orientation!: OzDividerOrientation

  /**
   * Thickness of divider in px
   */
  @Prop({ default: 0.5, type: Number }) thickness!: 0.5 | 8 | 12
}
